import React from "react";
import ReactIcon from "./React";
import NextIcon from "./Next";

function Card({
  icon: Icon,
  name,
  type,
  height = 1,
  href,
}: {
  icon: any;
  name: string;
  href: string;
  type?: "optional";
  height?: number;
}) {
  const external = href.indexOf("/") !== 0;
  return (
    <a
      href={href}
      target={external ? "_blank" : undefined}
      className={`relative px-2 py-6 flex items-center justify-between flex-col transition-colors bg-gray-50 rounded-lg no-underline hover:bg-gray-100 ${
        type === "optional"
          ? "border-gray-200 border-2 border-dashed"
          : "border-solid border-4 border-teal-300"
      }`}
    >
      {!external && (
        <svg
          className="w-6 h-6 absolute top-2 right-2 text-gray-300 hover:text-gray-400 transition-colors"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
            clipRule="evenodd"
          />
        </svg>
      )}
      <div className="flex items-center justify-center h-full">
        <Icon height={(type === "optional" ? 72 : 80) * height} />
      </div>
      <span
        className={`mt-4 text-center ${
          type === "optional" ? "text-gray-400" : "text-gray-500"
        } font-bold text-sm uppercase`}
      >
        {name}
      </span>
    </a>
  );
}

export default function TechnologiesGrid() {
  return (
    <div className="mb-12">
      <div
        className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3"
        style={{
          width: "125%",
          marginInlineStart: "50%",
          marginInlineEnd: "unset",
          transform: "translateX(-50%)",
          maxWidth: "calc(100vw - 2em)",
        }}
      >
        <Card icon={ReactIcon} name="React" href="https://reactjs.org" />
        <Card icon={NextIcon} name="Next.js" href="https://nextjs.org" />
        <Card icon={GraphQLIcon} name="GraphQL" href="https://graphql.org" />
      </div>
      <div
        className="grid grid-cols-3 gap-1 md:grid-cols-5"
        style={{
          width: "125%",
          marginInlineStart: "50%",
          marginInlineEnd: "unset",
          transform: "translateX(-50%)",
          maxWidth: "calc(100vw - 2em)",
        }}
      >
        <Card
          icon={TypeScriptIcon}
          name="TypeScript"
          type="optional"
          href="https://www.typescriptlang.org/"
        />
        <Card
          icon={PrismaIcon}
          name="Prisma"
          type="optional"
          height={0.9}
          href="/tools/prisma"
        />
        <Card
          icon={GraphQLCodegenIcon}
          name="GraphQL Codegen"
          type="optional"
          href="https://graphql-code-generator.com"
        />
        <Card
          icon={GraphQLYogaIcon}
          name="GraphQL Yoga"
          type="optional"
          href="https://graphql-yoga.com"
        />
        <Card
          icon={PothosIcon}
          name="Pothos"
          type="optional"
          height={0.75}
          href="/tools/pothos"
        />
        <Card
          icon={PrettierIcon}
          name="Prettier"
          type="optional"
          href="https://prettier.io"
        />
        <Card
          icon={StripeIcon}
          name="Stripe"
          type="optional"
          href="https://stripe.com"
        />
        <Card
          icon={PassportIcon}
          name="Passport"
          type="optional"
          height={0.75}
          href="http://passportjs.org"
        />
        <Card
          icon={ESLintIcon}
          name="ESLint"
          type="optional"
          href="https://eslint.org"
        />
        <Card
          icon={UrqlIcon}
          name="Urql"
          type="optional"
          height={1.25}
          href="/tools/urql"
        />
        {/* <Card icon={GitHubActionsIcon} name="GitHub Actions" type="opt-in" />
        <Card icon={DockerIcon} name="Docker" type="opt-in" /> */}
      </div>
    </div>
  );
}

function GraphQLCodegenIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 49 61"
      {...props}
    >
      <path
        fill="#E535AB"
        fillRule="evenodd"
        d="M8.849 38.1L0 42.525l19.91 11.06 8.85-4.424L8.849 38.1z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#CACACA"
        fillRule="evenodd"
        d="M23.295 48.866l.01-.006-.01-.005.01-.005-.01-.004.01-.005-.01-.005.01-.004-.01-.006.01-.004-.01-.005.01-.005-.01-.005.01-.005-.01-.006.01-.004-.01-.005.01-.004-.01-.006.01-.004-.01-.005.01-.005-.01-.005.01-.004-.01-.006.01-.005-.01-.005.01-.004-.01-.005.01-.005-.01-.005.01-.004-.01-.006.01-.004-.01-.005.01-.005-.01-.006.01-.004-.01-.005.01-.004-.01-.006.01-.004-.01-.005.01-.005-.01-.005.01-.005L8.63 40.558l-3.515 1.744.01.005-.01.004.01.005-.01.005.01.005-.01.005.01.004-.01.005.01.005-.01.005.01.005-.01.005.01.005-.01.005.01.005-.01.005.01.004-.01.005.01.005-.01.005.01.005-.01.005.01.005-.01.004.01.006-.01.004.01.005-.01.005.01.004-.01.005.01.005-.01.005.01.005-.01.005.01.005-.01.005.01.005-.01.004.01.006-.01.004.01.005-.01.005.01.005-.01.005.01.005-.01.005.01.005-.01.004.01.005-.01.005.01.005-.01.005.01.004-.01.005.01.005-.01.005.01.006-.01.004.01.005-.01.004.01.006-.01.004.01.005-.01.005.01.005-.01.004.01.006-.01.005.01.005-.01.004.01.005-.01.005.01.005-.01.004.01.006-.01.005.01.004-.01.005.01.005-.01.005.01.005-.01.004.01.006-.01.004.01.005-.01.005.01.005-.01.005.01.004-.01.005.01.006-.01.005.01.005-.01.004.01.005-.01.005.01.005-.01.004.01.006-.01.004.01.005-.01.005.01.005-.01.005.01.005-.01.004.01.006-.01.004.01.005-.01.005.01.005-.01.004.01.006-.01.005.01.005-.01.004.01.005-.01.005.01.005-.01.004.01.006-.01.004.01.005-.01.005.01.005-.01.005.01.005-.01.004.01.006-.01.004.01.005-.01.005.01.005-.01.004.01.005-.01.005.01.006-.01.005.01.004-.01.005.01.005-.01.005.01.005-.01.004.01.005-.01.005.01.005-.01.005.01.005-.01.005.01.005-.01.004.01.006-.01.004.01.005-.01.004.01.006-.01.004.01.005-.01.005.01.005-.01.005.01.005-.01.004.01.006-.01.004.01.006-.01.004.01.005-.01.005.01.005-.01.005.01.005-.01.005.01.005-.01.004.01.005-.01.005.01.005-.01.004.01.005-.01.005.01.005-.01.005.01.005-.01.004.01.005-.01.005.01.005-.01.005.01.005-.01.004.01.006-.01.004.01.006-.01.004.01.006-.01.004.01.006-.01.004.01.005-.01.005 14.676 8.089 3.514-1.744-.01-.005.01-.005-.01-.005.01-.004-.01-.006.01-.004-.01-.005.01-.004-.01-.006.01-.005-.01-.006.01-.004-.01-.005.01-.004-.01-.005.01-.005-.01-.005.01-.005-.01-.005.01-.005-.01-.005.01-.005-.01-.004.01-.005-.01-.005.01-.006-.01-.004.01-.005-.01-.005.01-.005-.01-.004.01-.005-.01-.005.01-.005-.01-.005.01-.004-.01-.006.01-.004-.01-.005.01-.005-.01-.005.01-.005-.01-.005.01-.005-.01-.005.01-.004-.01-.005.01-.005-.01-.005.01-.004-.01-.006.01-.005-.01-.004.01-.004-.01-.007.01-.004-.01-.005.01-.005-.01-.005.01-.004-.01-.005.01-.005-.01-.005.01-.006-.01-.003.01-.005-.01-.006.01-.005-.01-.004.01-.005-.01-.005.01-.005-.01-.005.01-.005-.01-.005.01-.005-.01-.004.01-.005-.01-.006.01-.004-.01-.005.01-.004-.01-.006.01-.004-.01-.005.01-.005-.01-.005.01-.005-.01-.005.01-.005-.01-.005.01-.004-.01-.005.01-.005-.01-.005.01-.004-.01-.006.01-.004-.01-.005.01-.005-.01-.006.01-.004-.01-.005.01-.004-.01-.006.01-.004-.01-.005.01-.005-.01-.005.01-.005-.01-.005.01-.005-.01-.005.01-.005-.01-.005.01-.004-.01-.005.01-.005-.01-.005.01-.004-.01-.005.01-.005-.01-.006.01-.004-.01-.006.01-.004-.01-.005.01-.004-.01-.006.01-.004-.01-.005.01-.005-.01-.005.01-.004-.01-.006.01-.005-.01-.005.01-.004-.01-.005.01-.005-.01-.005.01-.005-.01-.005.01-.005-.01-.004.01-.005-.01-.005.01-.005-.01-.005.01-.004-.01-.006.01-.004-.01-.005.01-.005-.01-.005.01-.005-.01-.004z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#F249C3"
        fillRule="evenodd"
        d="M0 42.525v6.636l19.91 11.062v-6.637L0 42.525z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#E535AB"
        fillRule="evenodd"
        d="M8.849 15.978l19.91-11.061 19.91 11.061L28.76 27.04 8.849 15.978z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#F249C3"
        fillRule="evenodd"
        d="M28.76 49.161V27.04L8.848 15.98V38.1L28.76 49.161z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#F7F7F7"
        fillRule="evenodd"
        d="M10.815 36.944V19.32l15.978 8.876v17.623l-15.978-8.875z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#D128A1"
        fillRule="evenodd"
        d="M48.67 15.978L28.76 27.04v22.122l-8.85 4.425v6.637l28.76-15.487V15.978z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M35.02 41.598c.014-.063.028-.126.036-.187l8.732-4.344.005.016-3.273 3.922c-.61-.238-1.455.163-1.98.98-.02.032-.035.066-.054.1l-3.466-.487zm-.392-6.876c.38-.593.489-1.25.342-1.74l3.278-3.522.034.016-4.375 10.498-.02-4.49c.297-.2.549-.46.74-.762h.001zm8.963-5.903c-.188.676-.055 1.317.396 1.606.209.134.46.17.72.13l.095 4.016c-.04.03-.081.06-.121.093l-4.412-5.958c.036-.049.075-.092.108-.144a2.54 2.54 0 00.172-.32l3.042.577zm-8.613 11.826a.998.998 0 00-.366-.49l4.42-10.603c.244-.05.49-.164.72-.33l4.438 5.991c-.017.025-.036.046-.053.072-.21.329-.341.675-.395 1l-8.764 4.36zm11.255-6.298c-.205-.132-.456-.16-.718-.11l-.094-3.977c.263-.18.512-.429.712-.74.573-.893.542-1.935-.07-2.329-.612-.393-1.573.013-2.146.905-.01.016-.016.031-.026.047l-3.144-.595c.068-.576-.114-1.104-.534-1.373-.663-.426-1.665-.047-2.238.846-.423.657-.492 1.408-.236 1.93l-3.2 3.435c-.612-.375-1.56.03-2.128.913-.574.894-.543 1.936.07 2.329.199.129.437.164.685.133l.021 4.521c-.274.18-.533.438-.74.76-.575.895-.543 1.937.07 2.33.61.394 1.572-.011 2.145-.906.038-.058.066-.118.098-.177l3.44.483c-.163.651-.028 1.262.41 1.542.61.394 1.572-.011 2.146-.905.424-.662.515-1.405.285-1.906l3.23-3.87c.587.262 1.443-.15 1.981-.99.574-.893.566-1.92-.019-2.296z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#262728"
        fillOpacity="0.134"
        fillRule="evenodd"
        d="M28.76 11.554c3.664 0 6.636 1.485 6.636 3.318s-2.972 3.319-6.637 3.319c-3.665 0-6.637-1.486-6.637-3.319s2.972-3.318 6.637-3.318"
        clipRule="evenodd"
      ></path>
      <path
        fill="#112F44"
        fillRule="evenodd"
        d="M26.547 11.751v3.121c0 .61.99 1.106 2.213 1.106 1.22 0 2.212-.495 2.212-1.106v-3.12h-4.425v-.001z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#112F44"
        fillRule="evenodd"
        d="M22.122 2.705l4.425 9.955c0 .611.99 1.107 2.213 1.107 1.22 0 2.212-.496 2.212-1.107l4.425-9.955H22.122z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#194360"
        fillRule="evenodd"
        d="M35.396 2.95c0 1.629-2.972 2.948-6.637 2.948-3.665 0-6.637-1.32-6.637-2.948 0-1.63 2.972-2.95 6.637-2.95 3.665 0 6.637 1.32 6.637 2.95"
        clipRule="evenodd"
      ></path>
      <path
        fill="#112F44"
        fillRule="evenodd"
        d="M28.76 5.285c-1.673 0-3.233-.3-4.394-.845-.93-.436-1.506-1.006-1.506-1.49 0-.485.576-1.056 1.506-1.491 1.16-.545 2.721-.845 4.393-.845 1.672 0 3.232.3 4.393.845.929.435 1.506 1.006 1.506 1.49 0 .485-.577 1.055-1.506 1.491-1.16.544-2.721.845-4.393.845"
        clipRule="evenodd"
      ></path>
      <path
        fill="#F7F7F7"
        fillRule="evenodd"
        d="M5.115 42.302l3.515-1.744 14.675 8.088-3.514 1.745-14.676-8.089z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

function PostmarkIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        transform="translate(.492 .492) scale(.4923)"
      >
        <path
          fill="#f0f0f0"
          d="M128 117v6a5 5 0 00-5 5h-6a5 5 0 10-10 0h-6a5 5 0 10-10 0h-6a5 5 0 10-10 0h-6a5 5 0 10-10 0h-6a5 5 0 10-10 0h-6a5 5 0 10-10 0h-6a5 5 0 10-10 0H5a5 5 0 00-5-5v-6a5 5 0 100-10v-6a5 5 0 000-10v-6a5 5 0 000-10v-6a5 5 0 000-10v-6a5 5 0 000-10v-6a5 5 0 000-10v-6a5 5 0 000-10V5a5 5 0 005-5h6a5 5 0 0010 0h6a5 5 0 0010 0h6a5 5 0 0010 0h6a5 5 0 0010 0h6a5 5 0 0010 0h6a5 5 0 0010 0h6a5 5 0 1010 0h6a5 5 0 005 5v6a5 5 0 100 10v6a5 5 0 100 10v6a5 5 0 100 10v6a5 5 0 100 10v6a5 5 0 100 10v6a5 5 0 100 10v6a5 5 0 100 10z"
        ></path>
        <path
          stroke="#ccc"
          d="M128.5 116.5v7h-.5a4.5 4.5 0 00-4.5 4.5v.5h-7v-.5a4.5 4.5 0 00-9 0v.5h-7v-.5a4.5 4.5 0 00-9 0v.5h-7v-.5a4.5 4.5 0 00-9 0v.5h-7v-.5a4.5 4.5 0 00-9 0v.5h-7v-.5a4.5 4.5 0 00-9 0v.5h-7v-.5a4.5 4.5 0 00-9 0v.5h-7v-.5a4.5 4.5 0 00-9 0v.5h-7v-.5a4.5 4.5 0 00-4.5-4.5h-.5v-7H0a4.5 4.5 0 000-9h-.5v-7H0a4.5 4.5 0 100-9h-.5v-7H0a4.5 4.5 0 100-9h-.5v-7H0a4.5 4.5 0 100-9h-.5v-7H0a4.5 4.5 0 100-9h-.5v-7H0a4.5 4.5 0 100-9h-.5v-7H0a4.5 4.5 0 100-9h-.5v-7H0A4.5 4.5 0 004.5 0v-.5h7V0a4.5 4.5 0 109 0v-.5h7V0a4.5 4.5 0 109 0v-.5h7V0a4.5 4.5 0 109 0v-.5h7V0a4.5 4.5 0 109 0v-.5h7V0a4.5 4.5 0 109 0v-.5h7V0a4.5 4.5 0 109 0v-.5h7V0a4.5 4.5 0 009 0v-.5h7V0a4.5 4.5 0 004.5 4.5h.5v7h-.5a4.5 4.5 0 000 9h.5v7h-.5a4.5 4.5 0 000 9h.5v7h-.5a4.5 4.5 0 000 9h.5v7h-.5a4.5 4.5 0 000 9h.5v7h-.5a4.5 4.5 0 000 9h.5v7h-.5a4.5 4.5 0 000 9h.5v7h-.5a4.5 4.5 0 000 9z"
        ></path>
        <path
          stroke="#fff"
          d="M127.5 117.478a5.5 5.5 0 010-10.956v-5.044a5.5 5.5 0 010-10.956v-5.044a5.5 5.5 0 010-10.956v-5.044a5.5 5.5 0 010-10.956v-5.044a5.5 5.5 0 010-10.956v-5.044a5.5 5.5 0 010-10.956v-5.044a5.5 5.5 0 010-10.956V5.478A5.502 5.502 0 01122.522.5h-5.044a5.5 5.5 0 01-10.956 0h-5.044a5.5 5.5 0 01-10.956 0h-5.044a5.5 5.5 0 01-10.956 0h-5.044a5.5 5.5 0 01-10.956 0h-5.044a5.5 5.5 0 01-10.956 0h-5.044a5.5 5.5 0 01-10.956 0h-5.044a5.5 5.5 0 01-10.956 0H5.478A5.502 5.502 0 01.5 5.478v5.044a5.5 5.5 0 010 10.956v5.044a5.5 5.5 0 010 10.956v5.044a5.5 5.5 0 010 10.956v5.044a5.5 5.5 0 010 10.956v5.044a5.5 5.5 0 010 10.956v5.044a5.5 5.5 0 010 10.956v5.044a5.5 5.5 0 010 10.956v5.044a5.502 5.502 0 014.978 4.978h5.044a5.5 5.5 0 0110.956 0h5.044a5.5 5.5 0 0110.956 0h5.044a5.5 5.5 0 0110.956 0h5.044a5.5 5.5 0 0110.956 0h5.044a5.5 5.5 0 0110.956 0h5.044a5.5 5.5 0 0110.956 0h5.044a5.5 5.5 0 0110.956 0h5.044a5.502 5.502 0 014.978-4.978z"
        ></path>
        <rect width="96" height="96" x="16" y="16" fill="#fedd00" rx="2"></rect>
        <rect
          width="95"
          height="95"
          x="16.5"
          y="16.5"
          stroke="#d9b500"
          rx="2"
        ></rect>
        <rect
          width="97"
          height="97"
          x="15.5"
          y="15.5"
          stroke="#fff"
          rx="2"
        ></rect>
        <path
          fill="#000"
          d="M50.3 86.084V42.3H43V35h25.886c16.168 0 19.522 10.664 19.522 18.06 0 5.934-2.408 10.492-4.902 12.986-4.042 4.042-9.546 4.988-17.888 4.988h-6.536v15.05h7.654v7.3H43v-7.3zm8.772-22.102h7.3c10.75 0 13.072-4.988 13.072-11.008 0-6.88-3.87-10.664-10.32-10.664H59.082z"
        ></path>
      </g>
    </svg>
  );
}

function DockerIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 217 156"
      {...props}
    >
      <path
        fill="#0091E2"
        d="M214.4 59.4c-.6-.5-6-4.6-17.6-4.6-3 0-6.1.3-9.1.8-2.2-15.3-14.9-22.7-15.4-23.1l-3.1-1.8-2 2.9c-2.5 3.9-4.4 8.3-5.5 12.8-2.1 8.7-.8 16.9 3.6 23.9-5.3 3-13.9 3.7-15.7 3.8H7.6c-3.7 0-6.7 3-6.7 6.7-.2 12.4 1.9 24.8 6.2 36.5 4.9 12.8 12.2 22.3 21.6 28.1 10.6 6.5 27.9 10.2 47.4 10.2 8.8 0 17.6-.8 26.3-2.4 12.1-2.2 23.7-6.4 34.4-12.5 8.8-5.1 16.7-11.6 23.4-19.2 11.3-12.7 18-26.9 22.9-39.5h2c12.3 0 19.9-4.9 24.1-9.1 2.8-2.6 4.9-5.8 6.4-9.4l.9-2.6-2.1-1.5z"
      ></path>
      <path
        fill="#0091E2"
        d="M20.8 70h19c.9 0 1.7-.7 1.7-1.7v-17c0-.9-.7-1.7-1.7-1.7h-19c-.9 0-1.7.7-1.7 1.7v17c.1 1 .8 1.7 1.7 1.7zM47 70h19c.9 0 1.7-.7 1.7-1.7v-17c0-.9-.7-1.7-1.7-1.7H47c-.9 0-1.7.7-1.7 1.7v17c.1 1 .8 1.7 1.7 1.7zm26.7 0h19c.9 0 1.7-.7 1.7-1.7v-17c0-.9-.7-1.7-1.7-1.7h-19c-.9 0-1.7.7-1.7 1.7v17c0 1 .7 1.7 1.7 1.7zm26.3 0h19c.9 0 1.7-.7 1.7-1.7v-17c0-.9-.7-1.7-1.7-1.7h-19c-.9 0-1.7.7-1.7 1.7v17c0 1 .8 1.7 1.7 1.7zM47 45.7h19c.9 0 1.7-.8 1.7-1.7V27c0-.9-.7-1.7-1.7-1.7H47c-.9 0-1.7.7-1.7 1.7v17c.1.9.8 1.7 1.7 1.7zm26.7 0h19c.9 0 1.7-.8 1.7-1.7V27c0-.9-.7-1.7-1.7-1.7h-19c-.9 0-1.7.7-1.7 1.7v17c0 .9.7 1.7 1.7 1.7zm26.3 0h19c.9 0 1.7-.8 1.7-1.7V27c0-.9-.8-1.7-1.7-1.7h-19c-.9 0-1.7.7-1.7 1.7v17c0 .9.8 1.7 1.7 1.7zm0-24.4h19c.9 0 1.7-.7 1.7-1.7v-17c0-.9-.8-1.7-1.7-1.7h-19c-.9 0-1.7.7-1.7 1.7v17c0 .9.8 1.7 1.7 1.7zM126.5 70h19c.9 0 1.7-.7 1.7-1.7v-17c0-.9-.7-1.7-1.7-1.7h-19c-.9 0-1.7.7-1.7 1.7v17c.1 1 .8 1.7 1.7 1.7z"
      ></path>
    </svg>
  );
}

function GitHubActionsIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 48 48"
      {...props}
    >
      <path
        stroke="var(--color-marketing-icon-primary, #2088FF)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10 1a9 9 0 019 9 9 9 0 01-9 9 9 9 0 01-9-9 9 9 0 019-9zm13 18a6 6 0 110 12 6 6 0 010-12zm0 16a6 6 0 110 12 6 6 0 010-12z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="var(--color-marketing-icon-secondary, #79B8FF)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M41 35a6 6 0 110 12 6 6 0 010-12z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="var(--color-marketing-icon-primary, #2088FF)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M25.037 23.607l-3.07 3.065-1.49-1.485"
      ></path>
      <path
        stroke="var(--color-marketing-icon-primary, #2088FF)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M41 19a6 6 0 110 12 6 6 0 010-12z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="var(--color-marketing-icon-primary, #2088FF)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M43.036 23.607l-3.069 3.065-1.49-1.485M7 6.812a1 1 0 011.533-.846l5.113 3.22a1 1 0 01-.006 1.697l-5.113 3.17A1 1 0 017 13.203V6.813zM9 19v15c0 3.866 3.177 7 7 7h1"
      ></path>
      <path
        fill="var(--color-marketing-icon-primary, #2088FF)"
        d="M16.949 26a1 1 0 100-2v2zM8 19.035A6.965 6.965 0 0014.965 26v-2A4.965 4.965 0 0110 19.035H8zM14.965 26h1.984v-2h-1.984v2z"
      ></path>
      <path
        stroke="var(--color-marketing-icon-primary, #2088FF)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M29.055 25h5.944"
      ></path>
      <path
        fill="var(--color-marketing-icon-secondary, #79B8FF)"
        fillRule="evenodd"
        d="M21 40a1 1 0 11-.001 2.001A1 1 0 0121 40zm4 0a1 1 0 11-.001 2.001A1 1 0 0125 40z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="var(--color-marketing-icon-secondary, #79B8FF)"
        strokeLinecap="round"
        strokeWidth="2"
        d="M34.005 41.007l-1.013.033"
      ></path>
    </svg>
  );
}

function PothosIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 120 120"
      fill="none"
      {...props}
    >
      <path
        fill="#5E8549"
        d="M117.4 62.6l-1 2.1c-.7 1.5-1.6 3-2.5 4.3v.1l-.2.2-.1.3-2.2 3.7a38 38 0 01-2.2-8l-.4-1.2-.5-1.3c-1-2.6-2-5.1-.1-7.4l.2-.3.5-.3.5-.2h.4c1 3 1.3 6 .7 9 0 .4.2.8.5.8h.2c.2 0 .7-.2.7-.7.3-3.2.5-6.5-.7-9.6l.2-.5.1-.3.2-.2c.2-.4.5-.6.8-.6h.6l.3.1.3.1 1.5 1a8 8 0 012.5 6l-.3 3v-.1zm-16.2 32.3L96.7 98l-1.1.7-2 1.3-.7.5.3-.2c1.6-3.1 4.1-4.8 6.7-4.8h.2c.3 0 .6-.2.7-.6v-.1c0-.3-.1-.5-.4-.6A20.8 20.8 0 0080 95.5c-3 2-6.4 5-6 8.5.1 2.2 1.5 3.6 4 4.6l-11.9 4.3a3.7 3.7 0 00-3.4-1.6 3.6 3.6 0 00-3 2.3c-2.6-.4-5.2-1.1-7.7-2.1l.2-.1h.2l.2-.2v-.1l.2-.2v-.7a1 1 0 00-.2-.5.7.7 0 00-.5-.2H52c-1.5 0-2.7-.5-4-1.3-1.6-1.4-3.2-3-4.4-5l-.7-.9c-1-1.3-2.2-2.5-3.4-3.7a6.9 6.9 0 00-2.9-1.4h-1.3l-.6.3-.4.5a4 4 0 00-.6 1l-.2.4v.1l-.1.2a12 12 0 00-2.3-1.7l-3.2-2-1.6-1a83 83 0 01-7.8-5.6 3.4 3.4 0 00-2-5.5 26.7 26.7 0 01-1.1-13.2c.5-5.4.7-9.8.7-13.8l1-1.5a11 11 0 00.6-9c-.3-.7-.7-1.5-1.4-2.3v-.5c-.8-3.4-1-7-1-10.5h.5a2.7 2.7 0 002.1-1 2.8 2.8 0 00.6-2.2 31 31 0 0114.2 0c2 .5 4 1.4 6.3 2.9-.6 0-1 .2-1.5.4-1.9.8-3.3 2.4-4.5 3.8a.7.7 0 00-.1.7l.3.2a15 15 0 0010.2-2l.3-.3a8 8 0 002.6.9l1.5.1 2.8.5c1.4.5 2.7 1.3 3.8 2.4 1.8 1.6 3.3 3.7 4.8 6.4l.2.6-.2-.2A7.3 7.3 0 0055 45h-.6v.1h-.7a.6.6 0 00-.5.4c-.2.4 0 1 .3 1.4a12 12 0 003 4.5 6 6 0 002.7 1.6l.9.2 1.7.4.1 1.5c.4 2.7.7 5.5.8 8.3H61c-2.7 0-5.5 0-8.3.2h-.4c-.8 0-1.8 0-2.3.5-.7.8-.2 2.5.5 4.5l.2.8c.8 3.4 1.7 6.7 2.7 10a50 50 0 011.8 6.5l.1.5c0 .8.2 1.6.8 2.2h.2c.7.5 1.7.6 2.6.6h.8c2.5.3 5 .3 7.4.1h2.8c1.3.1 2.6.2 4 0l.5-.1v-.5c0-1.6.4-3.2.8-4.7l4.1-16.6.2-.5c.4-1.1.7-2 .4-2.4-.2-1-1.1-1-1.5-1h-.2l-12.8-.1a15 15 0 004.6-3.7c.7-1 1.2-1.8 1.4-2.7l.3-2.2.1-1.5c0-.2 0-.4-.2-.6H71c-1.5.6-3 1.3-4.3 2.2a34.3 34.3 0 019-15c.8-.6 1.8-1 2.8-1.4 1-.3 1.8-.7 2.7-1.4 1-.8 1.8-1.6 2.6-2.5l1.3-1.4c3.1-2.9 7.9-3.2 11.7-3 4.8 0 9.5 1.5 13.5 4.1.2.5.5 1 .9 1.3.4.4.9.6 1.4.6.2 2.7 0 5.5-.2 8.1v.3c-1 1-1.7 2.2-2.3 3.5l-.1.3c-.4.7-.7 1.4-.9 2.2V52l.2.4v.3h-.2c-.6.2-1.2.4-1.6.8h-.2v.1c-.6.5-1 1.1-1.4 1.8v.3a6.7 6.7 0 00-.6 4.2l1 2.9.8 2.2.1.3.7 2.9c.6 2.7 1.5 5.4 2.7 7.9v.4h.2a.9.9 0 00.9.3l.4-.2.3-.4V76l.2-.1-.1-.2.4-1.6v4.5c0 2.2 0 4.3-.5 6.4a3.3 3.3 0 00-1.7 2 3.4 3.4 0 00.1 2.6 70.6 70.6 0 00-9.7 5.3zm-10.5 7.3l-.3.1v.3l-.4.9v.5c-.3 1.5-.8 3-1.6 4.1a4 4 0 01-2.7 2c-1 0-2.2-.2-2.5-1.3v-.1l-.2-.1v-.2c0-1.4.3-3.3 1-4.6.6-1.4 1.7-2.5 2.7-3.6.2-.2.2-.3.2-.5s0-.4-.2-.5c-.3-.3-.7-.3-1 0a13.8 13.8 0 00-3 4c-.6 1.6-1 3.2-1 4.8h-.3l-.1-.1v-.1h-1a7 7 0 01-3.2-1.2c-1.7-1.2-2.2-3-1.3-4.8 1.4-3 5-5.1 6.9-6.1 4.6-2.4 10-2.8 14.8-1.2-3.6 1.2-5.7 5-6.6 7.1l-.1.4v.2zm-77.5-44h.5v1.5l-.5-1.5zm22.7-42l.8-.6-.1.2v.2h-.2c-.7.7-1.4 1-2 1.5L36 16zM90.2 8l.5-.4c1 0 2.2 1 3.7 2.8 1.3 1.6 2.4 3.3 3.2 5.2l.3.5c.7 1.5 1.3 2.9 2.1 4.1l-.3-.1-2.6-.8c-1-.2-2.2-.2-3.3-.2-2.3 0-4.5-.5-6.6-1.5-.7-.4-1.1-1.2-1.1-2.3V15c0-1 .4-2 1-2.7l.2-.2.2-.2.2-.1a2 2 0 011-.2h.5l.4.1c.7 1 1.6 2 2.6 3h.5l.4-.2.2-.5c0-.2 0-.3-.2-.4-1-.8-1.8-1.8-2.5-3-.3-.6-.5-1.3-.5-2l.1-.7zm-49.6 6.7l.5-.3.3-.2h.2l.6-.4c1.1-.1 2.1-.6 3.3-1l3.7-2.3c.3-.1.4-.3.4-.6 0-.2-.1-.5-.4-.6a.4.4 0 00-.6 0c-2.2 1.5-4.6 3-7.4 3.3H41l-.6-.2H40c-.7-.3-1.3-.6-1.4-1.1l-.1-.5c0-.3 0-.6.2-.8.8-1.9 3.2-2.2 5-2.3l2-.1c2.3-.3 4.6-.4 6.8-1.3L52.2 8v.4l-.3 1.4c-.2 1-.4 2-.9 2.9a18 18 0 01-2.1 3.3 13.9 13.9 0 01-6 4.6c-1.2.4-2.5.5-3.7.2-1-.3-1.5-1-1.5-2v-1.1l.2-.2v-.2l.1-.2V17l.3-.3v-.1c.6-.8 1.4-1.4 2.3-1.8zM3.5 40.3l.3-2.3 1.3 1 .4.3.1.1c1 .8 2 1.3 3 1.7 2 .8 3.8 2 5.4 3.3l.2.2.4.4v.1l.1.1a7.7 7.7 0 011.8 5.3c0 1.4-.4 2.8-1 4-.3.6-.7 1-1.2 1.5 0 .2-.1.2-.3.2l-.5.1c-.5-.1-.8-.7-1-1.4l-.1-.4v-.2l-.4-1.2-.4-1.6c-.2-1-.6-2-1-3a.8.8 0 00-.7-.4c-.4 0-.7.1-.9.4-.2.3-.2.6 0 1 .4.8.7 1.7.9 2.6l.3 1.4.4 1.4v.3c0 1.1-.6 2.6-2.3 2.6-1 0-2.1-.3-3.1-1-1.7-1.1-2.6-3.3-2.7-6.2-.1-3.4.2-7 1-10.3zm34.1-5.7a5 5 0 012-.6L38 35c-.3.1-.3.6-.1.8.1.2.4.4.7.1h.1c.7-.5 1.4-1 2.3-1.1.5 0 1 .1 1.3.6-2.4 1.3-5.1 2-7.9 1.7 1-1 1.9-1.9 3.1-2.5zm17.9 11.7h.6l1.1.4a7 7 0 013.5 3l.5 1.7-2.3-2a.5.5 0 00-.7 0c-.1.2-.2.5 0 .7l2.6 2.1h-.4l-.5-.1-1.4-.4-1.1-1a15 15 0 01-3-4.2v-.2h1zm5.2-19.8a8 8 0 012.3 2.2c.3.5.7 1 .7 1.6 0 .2 0 .7-.3.8h-.2c-1-1.7-2.4-3.2-4-4.4a.5.5 0 00-.7 0v.6c1.4 1.2 2.9 2.4 3.8 4.1v.2c-.4.8-1.5 1-2.3.8-1-.4-1.7-1.5-2.1-2.4l-.5-1.8a16 16 0 00-1.9-4.2c2.2.7 3.9 1.5 5.2 2.5zm9.9 28a8 8 0 01-1.4 4.5c-.9 1-1.9 1.9-3 2.5l2.1-3.2c.2-.2.2-.5 0-.7h-.6l-2.1 3.1.6-3.6c.4-.7 1-1.2 1.7-1.5l2.7-1.5v.4zM33.4 103c2.3 2.5 5.2 4.4 8.4 5.4h.3c.1 0 .4 0 .5-.2.2-.2.3-.5.2-.8 0-.3-.3-.5-.6-.6-2.8-1-5.4-2.6-7.5-4.7v-.7l.3-.6v-.2l.1-.3.6-1.3c.5-.2 1.2 0 2.2.6l1 .8c1.3 1.2 2.4 2.7 3.4 4.1l.5.6c1.3 1.7 3 3.8 5.2 5-1 .2-2.2.2-3.3.2h-.1c-4.2 0-8.3-1-12.1-2.7l-.4-.4a2.7 2.7 0 01-.7-2.6c.3-.9 1-1.5 2-1.6zm53.8-93H87h.2zM76.9 72l-3 11.6a24 24 0 00-.8 4.5c-1 .2-2 0-3.2 0h-3c-3.4.3-6.7.2-10-.4-.3-.2-.4-1-.4-1.5l-.2-.6-1.8-6.6-1.5-4.6-.5-2.7h.3l2.3.1 11.6.2h10.1zm.6-2.6h-.3c-1.3.2-2.5.3-3.8.3-3.7.1-7.3-.1-11-.3l-5.5-.1-5 .3v-.5l-.4-.9a11 11 0 01-.6-3.3c.2-.2 1 0 1.3 0h.5l2.8-.2h5.4l17.2.1h.7l-.4 1.6-.3.8-.6 2.2zm4.4-35l-.7 1-.3.2c.3-1.6.5-3.2.3-5 0-.5-.9-.5-.8 0 0 2 0 3.7-.6 5.6-.3-.1-.6-.6-.7-2.6v-.1c0-1 0-2.2.3-3.2l.5-1.9.8-2.1.1.3c1 1.5 2 3 2.1 5 0 1-.3 2-1 2.9zM99.1 29a24 24 0 00-12.5 1.6 10 10 0 00-2.6 2v-.2c0-1.2-.1-2.6-.8-4L81.8 26l-1.1-2a.8.8 0 00-.8-.2c-.2.1-.3.2-.3.5v.2c.1 1.2-.3 2.4-.7 3.5-.3 1-.7 2.2-.9 3.6a15 15 0 00.2 3.7c.1.5.3 1.1.7 1.5l-1.3.6-1.4.5a15.1 15.1 0 00-4.6 4.4A34.1 34.1 0 0065.9 53c.5-7.1.5-14.5-2.2-21l.3-.1a2 2 0 00.7-2c-.1-1.4-1.3-2.7-2.1-3.6a21.2 21.2 0 00-8.2-4l-.7.1a.6.6 0 000 .8c1.1 1.6 2 3.4 2.5 5.3l1.3 3.2c.5.6 1.6 1.8 3 1.8.8 0 1.5-.2 2-.7 2 5 2.2 10.7 2.2 15.2a132 132 0 01-1 11.6c-.3-3.5-.5-7.1-1.8-10.5A26.4 26.4 0 0054.7 38a10.9 10.9 0 00-5.4-2.4l-1.4-.2a10.8 10.8 0 01-5.7-2 29 29 0 00-11.9-5.3c-3.2-.4-6.6-.4-9.8 0l7.5-5 3-1.5 2-1c1-.4 1.9-1 2.8-1.7 0 .8.3 1.5.8 2.1a3 3 0 001.8 1.3c.7.2 1.4.4 2.1.4a9 9 0 004.4-1.2c2-1.1 4-2.7 5.4-4.6a14 14 0 003.2-6.6v-.8h.2v-.2c2.8-2 6-3.6 9.2-5A2.9 2.9 0 0065.3 6a2.8 2.8 0 002.6-1.3c2.4 1 4.8 1.8 7.3 2.6l.6.3c3.2 1 6.4 2.4 9.4 4l-.5 1c-.8 2.2-.7 5.1 1.5 6.5 2.5 1.6 5.7 1.8 7.8 1.8 1.6 0 3.2.3 5 1L110.9 32l-.4.7A27.4 27.4 0 0099.1 29zm11.2 22.8v-.6c0-.7.3-1.4.6-2.1l.2-.3c.3-.8.7-1.6 1.2-2.2v4l-.8.3c-.5.2-.9.5-1.2 1zm9.1 6.6c-.2-2-1-3.9-2.5-5.3V53l-1-1h-.1l-.5-.5-.3-.1-.6-.4c0-2.2.2-4.5.3-6.5v-.1c.2-3 .5-5.8.2-8.8a2.7 2.7 0 00-2-4.7l-9.5-8.1c.2-.4.2-.7-.1-1a25.3 25.3 0 01-3.9-6.4l-.1-.3-1.4-2.8c-.8-1.4-1.8-2.8-2.9-4-1-1-2.6-2.5-4.4-2.5h-.3c-.7.2-1.3.5-1.6 1.1-.5.8-.5 1.8-.3 2.6-1.7-.9-3.6-1.3-5.5-1.3-2.2-1-4.3-2-6.5-2.7l-.5-.1c-2.6-.9-5.1-1.7-7.5-2.8a3 3 0 00-1-1.6 2.8 2.8 0 00-4.6 1.4c-3 1.2-6 2.7-8.7 4.5v-.2c0-.5.2-1.4.5-1.6.4-.4.3-1 0-1.3a.8.8 0 00-1.1-.1c-2 1.3-4.3 1.7-6.7 2h-1.6c-1.8.1-3.7.2-5.4 1-2 .7-3.7 2.7-3.1 5a3.2 3.2 0 001.8 2.1l-.1.1c-1 .4-2.2.7-3 1.5-.8.5-1.4 1-2 1.8l-.8 1.4-.2.1-.6.4h-.3l-1.1.6-.2.1c-1.2.5-2.4 1-3.6 1.8-3.2 2-6.3 4.2-9.3 6.4l-.2.2c-.4-.2-.8-.4-1.3-.4a2.7 2.7 0 00-2.1 1 2.8 2.8 0 00-.5 2.4l-.1.4.1 8v.7l.3 1.4c-1.3-.9-2.6-1.6-4-2.2a15.3 15.3 0 01-3.7-2.2c-.6-.5-1.7-1.3-1.7-1.8V35H4c-.2-.2-.5-.4-.8-.4-.2 0-.6.1-.8.4h-.2v.5c-.1 1.5-.4 3-.7 4.6v.4L.8 46a18 18 0 00.6 8.9 7.4 7.4 0 007 4.9 3 3 0 002.2-.8 3 3 0 001-1 14 14 0 011.6 7.7c0 1.6 0 3.1-.2 4.7v1.9a26 26 0 001.2 12.3c-.6.4-1 1-1.3 1.7a3.4 3.4 0 001 3.8 3 3 0 002 .7h.4c2.7 2.4 5.5 4.2 8 5.8l2 1.3.5.3 2 1.3.7.3c.7.6 1.7 1.2 2.5 2h-.3l-.9.7a4 4 0 00-1.4 3.8c.3 2.6 2.8 3.7 5.1 4.5 4.5 1.5 9.4 2 14 1.4 3.5 1.8 7.2 3 11 3.6 0 1 .5 1.9 1.2 2.5a3.6 3.6 0 005.1-.3 4 4 0 001-2.7v-.5l14.1-5.3.3-.1h.6c.3.7.8 1.3 1.4 1.6.6.4 1.3.6 2 .6h.5c1.8-.3 3.3-1.6 4.4-3.8l1.1-3h.2l.2-.1.1-.2 3.1-2.2h.2l1.7-1.1 1.4-1 4-2.8c3.7-2.4 7.4-4.4 11.1-6h.5c.8 0 1.6-.3 2.2-.8a3.4 3.4 0 00.6-4.3c-.4-.7-1-1.2-1.8-1.4.4-2 .4-4.2.4-6.3v-.7c-.1-2.9.1-5.7.7-8.5a28 28 0 003.2-6.2c.5-1.6.7-3.2.4-4.7"
      ></path>
    </svg>
  );
}

function GraphQLYogaIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 110 117"
      {...props}
    >
      <path
        fill="url(#paint0_linear_2_28)"
        d="M9.483 21.584c1.38 0 2.692.296 3.875.828l36.225-20.89C51.29.57 53.376 0 55.273 0c2.086 0 3.983.57 5.69 1.521l31.103 18.066c-2.276 1.521-3.983 3.803-5.12 6.466L56.79 8.557c-.569-.38-1.137-.38-1.706-.38-.57 0-1.139.19-1.708.38L18.63 28.573c.22.802.336 1.647.336 2.52 0 5.25-4.245 9.507-9.482 9.507C4.246 40.6 0 36.343 0 31.092c0-5.251 4.246-9.508 9.483-9.508z"
      ></path>
      <path
        fill="url(#paint1_linear_2_28)"
        d="M97.386 22.114a9.446 9.446 0 013.131-.53c5.237 0 9.483 4.257 9.483 9.508a9.51 9.51 0 01-4.658 8.188v39.068c0 4.184-2.276 7.987-5.69 10.079L68.55 106.303c0-2.853-.949-5.705-2.656-7.797L95.48 81.39c1.138-.57 1.707-1.712 1.707-3.043v-38.35a9.515 9.515 0 01-6.037-7.414 8.725 8.725 0 01-.222-1.967c0-1.902.569-3.614 1.707-5.135.095-.095.19-.238.284-.38.095-.143.19-.285.285-.38.569-.571.948-.951 1.517-1.332 0 0 .19 0 .19-.19.117-.117.234-.162.396-.224.1-.039.217-.084.362-.156 0 0 .19 0 .19-.19.19-.095.332-.143.474-.19a3.28 3.28 0 00.474-.19c.183-.047.377-.092.58-.136z"
      ></path>
      <path
        fill="url(#paint2_linear_2_28)"
        d="M64.187 104.792c.193.756.296 1.549.296 2.366 0 5.252-4.246 9.509-9.483 9.509-4.722 0-8.638-3.461-9.363-7.991L11.083 88.617c-3.603-2.092-5.69-5.895-5.69-10.079v-35.18c1.328.38 2.845.76 4.173.76 1.328 0 2.655-.19 3.793-.57v34.99c0 1.332.759 2.472 1.707 3.043l32.967 19.127A9.447 9.447 0 0155 97.65c4.417 0 8.129 3.028 9.183 7.127l.003.004v.011z"
      ></path>
      <path
        fill="url(#paint3_linear_2_28)"
        d="M86.115 67.215a5.792 5.792 0 00-1.709-4.125l-19.42-19.421C68.018 41.223 70 37.523 70 33.333 70 25.981 64.02 20 56.668 20c-7.352 0-13.333 5.981-13.333 13.333 0 4.19 1.982 7.89 5.014 10.336L28.928 63.09a5.794 5.794 0 00-1.71 4.124c0 1.558.607 3.024 1.71 4.125a5.773 5.773 0 003.268 1.624c-.104.337-.214.673-.277 1.027a8.278 8.278 0 001.38 6.227 8.278 8.278 0 005.38 3.427l16.413 2.894c.48.085.97.129 1.454.129.035 0 .066-.012.1-.012.049 0 .093.012.142.012.485 0 .974-.044 1.454-.128l16.413-2.894a8.279 8.279 0 005.379-3.427 8.277 8.277 0 001.38-6.227c-.063-.355-.173-.69-.277-1.026a5.773 5.773 0 003.269-1.625 5.796 5.796 0 001.709-4.126zM46.667 33.333c0-5.523 4.477-10 10-10s10 4.477 10 10c0 5.524-4.477 10-10 10s-10-4.476-10-10zm1.92 46.447c.15.851.448 1.639.827 2.373l-10.156-1.79a5 5 0 111.737-9.849l10.073 1.777c-1.959 1.861-2.984 4.633-2.48 7.489zm25.488.582l-16.413 2.895a5 5 0 01-1.736-9.848l16.413-2.894a5 5 0 111.736 9.848zm7.974-11.38a2.493 2.493 0 01-1.767.732c-.64 0-1.28-.244-1.768-.732L64.992 55.488a1.666 1.666 0 10-2.357 2.356l9.383 9.365c-.085.012-.173.008-.258.022l-15.093 2.662-15.093-2.66c-.086-.016-.172-.01-.258-.023l9.383-9.364a1.666 1.666 0 10-2.356-2.357L34.82 68.983a2.493 2.493 0 01-1.768.733 2.5 2.5 0 01-1.768-4.268l19.959-19.96a13.232 13.232 0 005.423 1.179c1.935 0 3.762-.435 5.423-1.18l19.96 19.96a2.5 2.5 0 010 3.535z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_2_28"
          x1="55"
          x2="55"
          y1="0"
          y2="116.667"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.411" stopColor="#59BDEF"></stop>
          <stop offset="0.854" stopColor="#ED2E7E"></stop>
          <stop offset="0.88" stopColor="#ED2E7E"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_2_28"
          x1="55"
          x2="55"
          y1="0"
          y2="116.667"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.411" stopColor="#59BDEF"></stop>
          <stop offset="0.854" stopColor="#ED2E7E"></stop>
          <stop offset="0.88" stopColor="#ED2E7E"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_2_28"
          x1="55"
          x2="55"
          y1="0"
          y2="116.667"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.411" stopColor="#59BDEF"></stop>
          <stop offset="0.854" stopColor="#ED2E7E"></stop>
          <stop offset="0.88" stopColor="#ED2E7E"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_2_28"
          x1="56.667"
          x2="56.667"
          y1="20"
          y2="86.667"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.411" stopColor="#59BDEF"></stop>
          <stop offset="0.854" stopColor="#ED2E7E"></stop>
          <stop offset="0.88" stopColor="#ED2E7E"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

function UrqlIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 600 595"
      {...props}
    >
      <defs>
        <path id="a" d="M0 .9h242.898v228.749H0z"></path>
        <path id="c" d="M0 .9h161.932v122.147H0z"></path>
        <path id="e" d="M0 .9h142.26v122.147H0z"></path>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#202020"
          d="M342.277 9.4l195.971 87.165C575.801 113.268 600 150.515 600 191.616v211.961c0 41.1-24.199 78.348-61.752 95.051l-195.971 87.165a104.029 104.029 0 01-84.554 0L61.752 498.628C24.199 481.925 0 444.678 0 403.578V191.615c0-41.1 24.199-78.348 61.752-95.05L257.723 9.4a104.029 104.029 0 0184.554 0z"
        ></path>
        <path
          stroke="#8196FF"
          strokeWidth="24.247"
          d="M553.161 442.006a68.635 68.635 0 01-29.745 25.342L332.27 552.082a79.877 79.877 0 01-64.741 0L76.38 467.348a68.635 68.635 0 01-29.745-25.342 68.635 68.635 0 01-11.113-37.463V190.841a68.635 68.635 0 0111.113-37.463 68.635 68.635 0 0129.745-25.342l191.148-84.733a79.877 79.877 0 0164.74 0l191.148 84.733a68.635 68.635 0 0129.745 25.342 68.635 68.635 0 0111.114 37.463v213.702a68.635 68.635 0 01-11.114 37.463z"
          opacity="0.499"
        ></path>
        <path
          stroke="#8196FF"
          strokeWidth="24.007"
          d="M573.14 453.712a91.94 91.94 0 01-39.77 33.949l-195.971 87.164a92.026 92.026 0 01-74.798 0l-195.97-87.164a91.94 91.94 0 01-39.772-33.949 91.94 91.94 0 01-14.856-50.135v-211.96A91.94 91.94 0 0126.86 141.48a91.94 91.94 0 0139.771-33.948l195.971-87.165a92.026 92.026 0 0174.798 0l195.97 87.165a91.94 91.94 0 0139.772 33.948 91.94 91.94 0 0114.856 50.135v211.961a91.94 91.94 0 01-14.856 50.135z"
        ></path>
        <text
          fill="#8196FF"
          fontFamily="Helvetica-Bold, Helvetica"
          fontSize="51"
          fontWeight="bold"
          letterSpacing="2"
          transform="translate(0 -10)"
        >
          <tspan x="223" y="464">
            URQL
          </tspan>
        </text>
        <g transform="translate(138 147.451)">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a"></use>
          </mask>
          <path
            fill="#8196FF"
            d="M135.063 169.782l45.166 45.214v14.653l15.112-14.763-33.75-33.789v-18.136l15.537 15.556 40.898.117 24.872 24.897v-26.5a33.88 33.88 0 00-9.908-23.944l-71.058-71.135-71.424-71.5a32.556 32.556 0 00-46.073 0L0 54.934h26.658c7.23-7.238 18.953-7.238 26.183 0l.316.316 54.296 54.354H80.768l-27.611-27.64v12.537a33.79 33.79 0 009.88 23.88l18.009 18.028 26.685 26.712a21.14 21.14 0 006.181 14.94l21.104 21.129 13.528 13.54-.104 12.55 12.751-11.127v14.391l14.571-13.888-40.699-40.743"
            mask="url(#b)"
          ></path>
        </g>
        <g transform="translate(299.932 147.451)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c"></use>
          </mask>
          <path
            fill="#647BED"
            d="M0 81.952l71.424-71.5a32.556 32.556 0 0146.073 0l44.435 44.482h-26.658c-7.23-7.238-18.953-7.238-26.183 0l-.316.316-67.724 67.797"
            mask="url(#d)"
          ></path>
        </g>
        <g transform="translate(198.724 147.451)">
          <mask id="f" fill="#fff">
            <use xlinkHref="#e"></use>
          </mask>
          <path
            fill="#A2B1FF"
            d="M142.259 123.047l-41.051-41.095-71.425-71.5A32.562 32.562 0 006.747.898 32.58 32.58 0 000 1.614a32.558 32.558 0 0116.29 8.837l71.423 71.5 41.01 41.055 13.536.04z"
            mask="url(#f)"
          ></path>
        </g>
        <path
          fill="#A2B1FF"
          d="M203.975 268.774h58.135l11.707-11.718h-55.05l-27.61-27.64v12.537a33.79 33.79 0 009.88 23.88l2.938 2.941z"
        ></path>
        <path
          fill="#4D65DD"
          d="M354.523 309.991a3.252 3.252 0 003.25 3.255 3.252 3.252 0 003.251-3.255 3.252 3.252 0 00-3.25-3.254h-3.251v3.254z"
        ></path>
        <path
          fill="#647BED"
          d="M215.456 198.648c-12.929-12.943-33.89-12.943-46.817 0l-2.152 2.154c7.26-5.59 17.703-5.074 24.354 1.584l.124.123h.192l66.02 66.277 28.053-.29-66.379-66.449-3.395-3.399z"
        ></path>
        <path
          fill="#4D65DD"
          d="M384.327 198.648c12.929-12.943 33.89-12.943 46.817 0l2.152 2.154c-7.26-5.59-17.704-5.074-24.354 1.584l-.124.123h-.192l-67.683 67.95-14.175-14.19 54.162-54.222 3.397-3.399zm-150.983 99.527l12.387 12.4a21.14 21.14 0 006.181 14.939l21.104 21.127 13.528 13.541-.104 12.55 12.751-11.126v14.391l14.571-13.89-40.699-40.742 1.995-2.136 43.17 43.219V377.1l15.114-14.763-33.752-33.788v-18.137a41.72 41.72 0 00-29.513-12.237h-36.733z"
        ></path>
        <path
          fill="#647BED"
          d="M313.762 362.108l-40.7-40.743-23.165-23.19h-16.553l12.386 12.4a21.14 21.14 0 006.182 14.939l21.105 21.127 13.528 13.542-.105 12.55 12.752-11.128v14.392l14.57-13.89z"
        ></path>
        <path
          fill="#8196FF"
          d="M417.428 157.903a32.556 32.556 0 00-23.036-9.552c-2.286 0-4.545.247-6.747.714a32.548 32.548 0 0116.289 8.838l44.435 44.483h13.495l-44.436-44.483z"
        ></path>
      </g>
    </svg>
  );
}

function ESLintIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 324 285.096"
      {...props}
    >
      <path
        fill="#8080F2"
        d="M98.764 104.305l60.777-35.09a4.916 4.916 0 014.917 0l60.778 35.09a4.92 4.92 0 012.458 4.258v70.179c0 1.755-.938 3.38-2.458 4.259l-60.778 35.089a4.916 4.916 0 01-4.917 0L98.764 183a4.919 4.919 0 01-2.458-4.258v-70.179a4.922 4.922 0 012.458-4.258"
      ></path>
      <path
        fill="#4b32c3"
        d="M320.02 136.27L247.405 9.937C244.766 5.37 239.894 2 234.619 2H89.383c-5.276 0-10.15 3.37-12.788 7.937L3.978 135.991c-2.637 4.57-2.637 10.335 0 14.905l72.617 125.297c2.638 4.568 7.512 6.903 12.788 6.903h145.235c5.274 0 10.148-2.265 12.785-6.834l72.616-125.502c2.64-4.566 2.64-9.922.002-14.49m-60.131 60.749c0 1.857-1.118 3.575-2.728 4.505l-92.498 53.367a5.263 5.263 0 01-5.233 0l-92.57-53.367c-1.609-.93-2.734-2.646-2.734-4.505V90.284c0-1.858 1.109-3.575 2.719-4.505l92.494-53.367a5.252 5.252 0 015.23 0l92.577 53.367c1.61.93 2.743 2.647 2.743 4.505z"
      ></path>
    </svg>
  );
}

function PrettierIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 210 210" {...props}>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(0 200)">
          <rect
            width="60"
            height="10"
            x="150"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect
            width="70"
            height="10"
            x="70"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect width="60" height="10" fill="#EA5E5E" rx="5"></rect>
        </g>
        <g transform="translate(0 180)">
          <rect
            width="50"
            height="10"
            x="160"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect
            width="20"
            height="10"
            x="130"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect
            width="50"
            height="10"
            x="70"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect width="20" height="10" x="40" fill="#F7B93E" rx="5"></rect>
          <rect width="30" height="10" fill="#56B3B4" rx="5"></rect>
        </g>
        <g transform="translate(0 160)">
          <rect
            width="100"
            height="10"
            x="110"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect
            width="30"
            height="10"
            x="70"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect width="60" height="10" fill="#BF85BF" rx="5"></rect>
        </g>
        <g transform="translate(0 140)">
          <rect
            width="30"
            height="10"
            x="180"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect
            width="30"
            height="10"
            x="140"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect width="100" height="10" x="30" fill="#F7B93E" rx="5"></rect>
          <rect width="20" height="10" fill="#BF85BF" rx="5"></rect>
        </g>
        <g transform="translate(0 120)">
          <rect
            width="40"
            height="10"
            x="170"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect width="40" height="10" x="120" fill="#BF85BF" rx="5"></rect>
          <rect width="50" height="10" x="60" fill="#EA5E5E" rx="5"></rect>
          <rect width="50" height="10" fill="#56B3B4" rx="5"></rect>
        </g>
        <g transform="translate(0 100)">
          <rect
            width="30"
            height="10"
            x="180"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect width="90" height="10" x="80" fill="#56B3B4" rx="5"></rect>
          <rect width="40" height="10" x="30" fill="#F7B93E" rx="5"></rect>
          <rect width="20" height="10" fill="#EA5E5E" rx="5"></rect>
        </g>
        <g transform="translate(0 80)">
          <rect
            width="20"
            height="10"
            x="190"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect width="60" height="10" x="120" fill="#F7B93E" rx="5"></rect>
          <rect
            width="40"
            height="10"
            x="70"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect width="60" height="10" fill="#BF85BF" rx="5"></rect>
        </g>
        <g transform="translate(0 60)">
          <rect
            width="20"
            height="10"
            x="190"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect width="60" height="10" x="120" fill="#EA5E5E" rx="5"></rect>
          <rect
            width="40"
            height="10"
            x="70"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect width="20" height="10" x="40" fill="#56B3B4" rx="5"></rect>
          <rect width="30" height="10" fill="#F7B93E" rx="5"></rect>
        </g>
        <g transform="translate(0 40)">
          <rect
            width="30"
            height="10"
            x="180"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect width="20" height="10" x="150" fill="#56B3B4" rx="5"></rect>
          <rect width="50" height="10" x="90" fill="#BF85BF" rx="5"></rect>
          <rect width="80" height="10" fill="#56B3B4" rx="5"></rect>
        </g>
        <g transform="translate(0 20)">
          <rect
            width="40"
            height="10"
            x="170"
            fill="#CFD4D7"
            opacity="0.5"
            rx="5"
          ></rect>
          <rect width="110" height="10" x="50" fill="#F7B93E" rx="5"></rect>
          <rect width="40" height="10" fill="#EA5E5E" rx="5"></rect>
        </g>
        <rect
          width="70"
          height="10"
          x="140"
          fill="#CFD4D7"
          opacity="0.5"
          rx="5"
        ></rect>
        <rect width="130" height="10" fill="#56B3B4" rx="5"></rect>
      </g>
    </svg>
  );
}

function GraphQLIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" {...props}>
      <path
        fill="#E535AB"
        d="M57.468 302.66l-14.376-8.3 160.15-277.38 14.376 8.3z"
      ></path>
      <path fill="#E535AB" d="M39.8 272.2h320.3v16.6H39.8z"></path>
      <path
        fill="#E535AB"
        d="M206.348 374.026l-160.21-92.5 8.3-14.376 160.21 92.5zm139.174-241.08l-160.21-92.5 8.3-14.375 160.21 92.5z"
      ></path>
      <path
        fill="#E535AB"
        d="M54.482 132.883l-8.3-14.375 160.21-92.5 8.3 14.375z"
      ></path>
      <path
        fill="#E535AB"
        d="M342.568 302.663l-160.15-277.38 14.376-8.3 160.15 277.38zM52.5 107.5h16.6v185H52.5z"
      ></path>
      <path fill="#E535AB" d="M330.9 107.5h16.6v185h-16.6z"></path>
      <path
        fill="#E535AB"
        d="M203.522 367l-7.25-12.558 139.34-80.45 7.25 12.557z"
      ></path>
      <path
        fill="#E535AB"
        d="M369.5 297.9c-9.6 16.7-31 22.4-47.7 12.8-16.7-9.6-22.4-31-12.8-47.7 9.6-16.7 31-22.4 47.7-12.8 16.8 9.7 22.5 31 12.8 47.7M90.9 137c-9.6 16.7-31 22.4-47.7 12.8-16.7-9.6-22.4-31-12.8-47.7 9.6-16.7 31-22.4 47.7-12.8 16.7 9.7 22.4 31 12.8 47.7M30.5 297.9c-9.6-16.7-3.9-38 12.8-47.7 16.7-9.6 38-3.9 47.7 12.8 9.6 16.7 3.9 38-12.8 47.7-16.8 9.6-38.1 3.9-47.7-12.8M309.1 137c-9.6-16.7-3.9-38 12.8-47.7 16.7-9.6 38-3.9 47.7 12.8 9.6 16.7 3.9 38-12.8 47.7-16.7 9.6-38.1 3.9-47.7-12.8M200 395.8c-19.3 0-34.9-15.6-34.9-34.9 0-19.3 15.6-34.9 34.9-34.9 19.3 0 34.9 15.6 34.9 34.9 0 19.2-15.6 34.9-34.9 34.9M200 74c-19.3 0-34.9-15.6-34.9-34.9 0-19.3 15.6-34.9 34.9-34.9 19.3 0 34.9 15.6 34.9 34.9 0 19.3-15.6 34.9-34.9 34.9"
      ></path>
    </svg>
  );
}

function TypeScriptIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 128 128"
      {...props}
    >
      <rect width="128" height="128" fill="#3178c6" rx="6"></rect>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M74.262 99.468v14.026c2.273 1.168 4.96 2.045 8.063 2.629 3.102.585 6.373.877 9.81.877 3.35 0 6.533-.321 9.548-.964 3.016-.643 5.659-1.702 7.932-3.178a16.179 16.179 0 005.397-5.786c1.325-2.381 1.988-5.325 1.988-8.831 0-2.542-.379-4.77-1.136-6.684a15.632 15.632 0 00-3.278-5.107c-1.427-1.49-3.139-2.827-5.134-4.01-1.996-1.183-4.246-2.301-6.752-3.353a84.756 84.756 0 01-4.938-2.213c-1.456-.716-2.695-1.447-3.714-2.192-1.02-.745-1.806-1.534-2.36-2.367-.553-.832-.83-1.775-.83-2.827 0-.964.247-1.833.743-2.608s1.194-1.439 2.097-1.994c.903-.555 2.01-.986 3.321-1.293 1.311-.307 2.768-.46 4.37-.46 1.166 0 2.396.088 3.693.263 1.296.175 2.6.445 3.911.81a27.158 27.158 0 013.824 1.381 21.071 21.071 0 013.43 1.929V54.41c-2.127-.819-4.45-1.425-6.97-1.82S101.866 52 98.603 52c-3.321 0-6.468.358-9.44 1.074-2.97.716-5.586 1.833-7.843 3.353a16.732 16.732 0 00-5.353 5.807C74.656 64.586 74 67.4 74 70.672c0 4.178 1.202 7.743 3.605 10.694 2.404 2.951 6.052 5.45 10.947 7.495 1.923.789 3.714 1.563 5.375 2.323 1.66.76 3.095 1.549 4.304 2.367s2.163 1.71 2.862 2.673c.7.965 1.049 2.06 1.049 3.288 0 .906-.218 1.746-.655 2.52s-1.1 1.446-1.988 2.016c-.89.57-1.996 1.016-3.322 1.337-1.325.321-2.877.482-4.654.482-3.03 0-6.03-.533-9.002-1.6-2.971-1.066-5.724-2.666-8.259-4.799zm-23.56-34.914H69V53H18v11.554h18.208V116h14.495z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

function PassportIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 500" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#D6FF00"
          d="M200 0C89.5 0 0 89.5 0 200h100c0-55.2 44.8-100 100-100V0z"
        ></path>
        <path
          fill="#34E27A"
          d="M400 200C400 89.5 310.5 0 200 0v100c55.2 0 100 44.8 100 100h100z"
        ></path>
        <path
          fill="#00B9F1"
          d="M200 400c110.5 0 200-89.5 200-200H300c0 55.2-44.8 100-100 100v100z"
        ></path>
        <path fill="#000" d="M100 400V200H0v300h200V400H100z"></path>
      </g>
    </svg>
  );
}

function StripeIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      version="1.1"
      viewBox="0 0 468 222.5"
      xmlSpace="preserve"
      {...props}
    >
      <path
        d="M414 113.4c0-25.6-12.4-45.8-36.1-45.8-23.8 0-38.2 20.2-38.2 45.6 0 30.1 17 45.3 41.4 45.3 11.9 0 20.9-2.7 27.7-6.5v-20c-6.8 3.4-14.6 5.5-24.5 5.5-9.7 0-18.3-3.4-19.4-15.2h48.9c0-1.3.2-6.5.2-8.9zm-49.4-9.5c0-11.3 6.9-16 13.2-16 6.1 0 12.6 4.7 12.6 16h-25.8zm-63.5-36.3c-9.8 0-16.1 4.6-19.6 7.8l-1.3-6.2h-22v116.6l25-5.3.1-28.3c3.6 2.6 8.9 6.3 17.7 6.3 17.9 0 34.2-14.4 34.2-46.1-.1-29-16.6-44.8-34.1-44.8zm-6 68.9c-5.9 0-9.4-2.1-11.8-4.7l-.1-37.1c2.6-2.9 6.2-4.9 11.9-4.9 9.1 0 15.4 10.2 15.4 23.3 0 13.4-6.2 23.4-15.4 23.4zm-71.3-74.8l25.1-5.4V36l-25.1 5.3zm0 7.6h25.1v87.5h-25.1zm-26.9 7.4l-1.6-7.4h-21.6v87.5h25V97.5c5.9-7.7 15.9-6.3 19-5.2v-23c-3.2-1.2-14.9-3.4-20.8 7.4zm-50-29.1l-24.4 5.2-.1 80.1c0 14.8 11.1 25.7 25.9 25.7 8.2 0 14.2-1.5 17.5-3.3V135c-3.2 1.3-19 5.9-19-8.9V90.6h19V69.3h-19l.1-21.7zM79.3 94.7c0-3.9 3.2-5.4 8.5-5.4 7.6 0 17.2 2.3 24.8 6.4V72.2c-8.3-3.3-16.5-4.6-24.8-4.6C67.5 67.6 54 78.2 54 95.9c0 27.6 38 23.2 38 35.1 0 4.6-4 6.1-9.6 6.1-8.3 0-18.9-3.4-27.3-8v23.8c9.3 4 18.7 5.7 27.3 5.7 20.8 0 35.1-10.3 35.1-28.2-.1-29.8-38.2-24.5-38.2-35.7z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#635BFF"
      ></path>
    </svg>
  );
}

function PrismaIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 106 128"
      {...props}
    >
      <path
        fill="#000"
        fillRule="evenodd"
        d="M105.306 97.519L61.284 4.037v-.002A7.062 7.062 0 0055.265.013c-2.679-.156-5.079 1.136-6.433 3.335L1.088 80.678a7.233 7.233 0 00.084 7.763l23.338 36.152c1.391 2.158 3.801 3.407 6.306 3.407.71 0 1.424-.1 2.126-.308l67.744-20.036a7.424 7.424 0 004.66-4.028 7.264 7.264 0 00-.04-6.11zm-9.857 4.01l-57.479 17c-1.756.52-3.439-.999-3.07-2.77l20.534-98.34c.384-1.838 2.926-2.13 3.728-.427l38.02 80.736c.717 1.523-.1 3.319-1.733 3.801z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
